export default function updateDocumentHeight() {
    if (parent) {
        let heightObjectID = "size-container";
        let newHeight = document.getElementById(heightObjectID).offsetHeight;
        let height =
            {
                type: "oevdigital.iframe.resize",
                height: newHeight
            };
        parent.postMessage(height, "*");
    }
};

